import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'setIconClass',
})
export class SetIconClassPipe implements PipeTransform {

    transform(value: string, args?: any): any {

        let output: string = '';

        switch (value) {
            case 'Structure':
                output = 'fa-folder';
                break;
            case 'Folder':
                output = 'fa-folder-open';
                break;
            case 'Document':
                output = 'fa-file-text';
                break;
            case 'Address':
                output = 'fa-address-card';
                break;
            case 'Meeting':
                output = 'fa-users';
                break;
            case 'Global':
                output = 'fa-globe';
                break;
        }

        return output;
    }
}



// WEBPACK FOOTER //
// ./src/shared/set-icon-class.pipe.ts